// extracted by mini-css-extract-plugin
export default {"wrapper":"CompetenceComponent_wrapper__Jeoro","wrapperInTable":"CompetenceComponent_wrapperInTable__SeoF-","disabled":"CompetenceComponent_disabled__urN3K"};